import { Middleware } from 'redux';

import { LOAD_USER, hideLoading, loadUserSuccess, showLoading } from './actions';
import { RoomService } from '../../../core/services/room';
import { RootState } from '../../../core/store/store';
import { toast } from 'react-toastify';

const loadUserMiddleware: Middleware<{}, RootState> = ({ dispatch, getState }) => next => (action: any) => {
    next(action);
    // const state = getState()
    if (action.type === LOAD_USER) {
        dispatch(showLoading());

        RoomService.loadUserRoomAccess()
            .then(response => {
                dispatch(loadUserSuccess(response.data))
                dispatch(hideLoading());
            })
            .catch(error => {
                toast.error('Loading user access list failed, Incorrect credentials or server error!');
                dispatch(hideLoading());
            });
    }
}


export const userMiddleware = [loadUserMiddleware];